import * as actionTypes from "./actionTypes";

export const shownMFAlert = () => {
  return {
    type: actionTypes.SHOWN_MF_ALERT,
  };
};

/*===== PROFILE DETAILS =====*/
export const getConsumerDetail = (enableLoading = true) => {
  return {
    type: actionTypes.GET_CONSUMER_DETAILS,
    enableLoading,
  };
};

export const getConsumerDetailSuccess = (data) => {
  return {
    type: actionTypes.GET_CONSUMER_DETAILS_SUCCESS,
    data,
  };
};

export const updateConsumer = (data) => {
  return {
    type: actionTypes.UPDATE_CONSUMER,
    data,
  };
};

export const updateConsumerSuccess = (data) => {
  return {
    type: actionTypes.UPDATE_CONSUMER_SUCCESS,
    data,
  };
};

export const updateConsumerFail = (data) => {
  return {
    type: actionTypes.UPDATE_CONSUMER_FAIL,
    data,
  };
};

export const verifyConsumerAcc = (data) => {
  return {
    type: actionTypes.VERIFY_CONSUMER_ACC,
    data,
  };
};

export const verifyConsumerAccSuccess = (data) => {
  return {
    type: actionTypes.VERIFY_CONSUMER_ACC_SUCCESS,
    data,
  };
};

export const verifyConsumerAccFail = (data) => {
  return {
    type: actionTypes.VERIFY_CONSUMER_ACC_FAIL,
    data,
  };
};

export const uploadConsumerProfileImg = (data) => {
  return {
    type: actionTypes.UPLOAD_CONSUMER_IMG,
    data,
  };
};

export const uploadConsumerProfileImgSuccess = (data) => {
  return {
    type: actionTypes.UPLOAD_CONSUMER_IMG_SUCCESS,
    data,
  };
};

export const changePhoneNoSentSMS = (data) => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_SENT_SMS,
    data,
  };
};

export const changePhoneNoSentSMSSuccess = () => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_SENT_SMS_SUCCESS,
  };
};

export const changePhoneNoSentSMSFail = () => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_SENT_SMS_FAIL,
  };
};

export const changePhoneNoVerifyPhone = (data) => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_VERIFY_SMS,
    data,
  };
};

export const changePhoneNoVerifyPhoneSuccess = () => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_VERIFY_SMS_SUCCESS,
  };
};

export const changePhoneNoVerifyPhoneFail = () => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_VERIFY_SMS_FAIL,
  };
};

export const changePhoneNoUpdate = (data1, data2) => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_UPDATE,
    data1,
    data2,
  };
};

export const changePhoneNoUpdateSuccess = () => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_UPDATE_SUCCESS,
  };
};

export const changePhoneNoUpdateFail = () => {
  return {
    type: actionTypes.CHANGE_PHONE_NO_UPDATE_FAIL,
  };
};
/*===== END PROFILE DETAILS =====*/

/*===== DELIVERY FEE =====*/
export const getDeliveryFee = () => {
  return {
    type: actionTypes.GET_DELIVERY_FEE,
  };
};

export const getDeliveryFeeSuccess = (data) => {
  return {
    type: actionTypes.GET_DELIVERY_FEE_SUCCESS,
    data,
  };
};

export const getDeliveryFeeFail = () => {
  return {
    type: actionTypes.GET_DELIVERY_FEE_FAIL,
  };
};
/*===== END DELIVERY FEE =====*/

/*===== ADDRESS =====*/
// GET
export const getConsumerAddress = () => {
  return {
    type: actionTypes.GET_CONSUMER_ADDRESS,
  };
};

export const getConsumerAddressSuccess = (data) => {
  return {
    type: actionTypes.GET_CONSUMER_ADDRESS_SUCCESS,
    data,
  };
};

export const getConsumerAddressFail = () => {
  return {
    type: actionTypes.GET_CONSUMER_ADDRESS_FAIL,
  };
};

// ADD
export const addConsumerAddress = (data) => {
  return {
    type: actionTypes.ADD_CONSUMER_ADDRESS,
    data,
  };
};

export const addConsumerAddressSuccess = () => {
  return {
    type: actionTypes.ADD_CONSUMER_ADDRESS_SUCCESS,
  };
};

export const addConsumerAddressFail = () => {
  return {
    type: actionTypes.ADD_CONSUMER_ADDRESS_FAIL,
  };
};

// UPDATE
export const updateConsumerAddress = (data) => {
  return {
    type: actionTypes.UPDATE_CONSUMER_ADDRESS,
    data,
  };
};

export const updateConsumerAddressSuccess = () => {
  return {
    type: actionTypes.UPDATE_CONSUMER_ADDRESS_SUCCESS,
  };
};

export const updateConsumerAddressFail = () => {
  return {
    type: actionTypes.UPDATE_CONSUMER_ADDRESS_FAIL,
  };
};

// DELETE
export const deleteConsumerAddress = (data) => {
  return {
    type: actionTypes.DELETE_CONSUMER_ADDRESS,
    data,
  };
};

export const deleteConsumerAddressSuccess = () => {
  return {
    type: actionTypes.DELETE_CONSUMER_ADDRESS_SUCCESS,
  };
};

export const deleteConsumerAddressFail = () => {
  return {
    type: actionTypes.DELETE_CONSUMER_ADDRESS_FAIL,
  };
};
/*===== END ADDRESS =====*/

/*===== CHANGE PASSWORD =====*/
export const changePassword = (data) => {
  return {
    type: actionTypes.CHANGE_PASSWORD,
    data,
  };
};

export const changePasswordSuccess = (data) => {
  return {
    type: actionTypes.CHANGE_PASSWORD_SUCCESS,
    data,
  };
};

export const changePasswordFail = () => {
  return {
    type: actionTypes.CHANGE_PASSWORD_FAIL,
  };
};
/*===== END CHANGE PASSWORD =====*/

/*===== SETUP NOTIFICATION =====*/
export const setupNotification = (data) => {
  return {
    type: actionTypes.SETUP_NOTIFICATION,
    data,
  };
};

export const setupNotificationSuccess = () => {
  return {
    type: actionTypes.SETUP_NOTIFICATION_SUCCESS,
  };
};

export const setupNotificationFail = () => {
  return {
    type: actionTypes.SETUP_NOTIFICATION_FAIL,
  };
};
/*===== END SETUP NOTIFICATION =====*/

/*===== CONSUMER RESTAURANT ORDER  =====*/
export const consumerGetOrder = (status, data) => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_ORDER,
    status,
    data,
  };
};
export const consumerGetOrderSuccess = (status, data) => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_ORDER_SUCCESS,
    status,
    data,
  };
};
export const consumerOrderDetail = (id) => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_ORDER_DETAIL,
    id,
  };
};
export const consumerOrderDetailSuccess = (data) => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_ORDER_DETAIL_SUCCESS,
    data,
  };
};

export const restaurantOrderReview = (rid, orderID, data) => {
  return {
    type: actionTypes.RESTAURANT_ORDER_REVIEW,
    rid,
    orderID,
    data,
  };
};
export const restaurantOrderReviewSuccess = () => {
  return {
    type: actionTypes.RESTAURANT_ORDER_REVIEW_SUCCESS,
  };
};

export const restaurantRiderReview = (
  rid,
  orderID,
  riderID,
  dataShop,
  dataRider
) => {
  return {
    type: actionTypes.RESTAURANT_ORDER_RIDER_REVIEW,
    rid,
    orderID,
    riderID,
    dataShop,
    dataRider,
  };
};
export const restaurantRiderReviewSuccess = () => {
  return {
    type: actionTypes.RESTAURANT_ORDER_RIDER_REVIEW_SUCCESS,
  };
};

export const consumerCancelOrderRestaurant = (data) => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_CANCEL_ORDER,
    data,
  };
};
export const consumerCancelOrderRestaurantSuccess = () => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_CANCEL_ORDER_SUCCESS,
  };
};

export const consumerCompleteOrderRes = (id) => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_COMPLETE_ORDER,
    id,
  };
};
export const consumerCompleteOrderResSuccess = () => {
  return {
    type: actionTypes.RESTAURANT_CONSUMER_COMPLETE_ORDER_SUCCESS,
  };
};

/*===== END CONSUMER RESTAURANT ORDER  =====*/

/*=====  BECOME MERCHANT  =====*/
export const storeBecomerMerchantData = (data, documents) => {
  return {
    type: actionTypes.STORE_BECOME_MERCHANT_DATA,
    data,
    documents,
  };
};

export const becomerMerchant = (data, documents) => {
  return {
    type: actionTypes.BECOME_MERCHANT,
    data,
    documents,
  };
};
export const becomerMerchantSuccess = () => {
  return {
    type: actionTypes.BECOME_MERCHANT_SUCCESS,
  };
};
export const becomerMerchantFail = () => {
  return {
    type: actionTypes.BECOME_MERCHANT_FAIL,
  };
};
/*===== END BECOME MERCHANT  =====*/

/*=====  BECOME MERCHANT V2  =====*/
export const becomerMerchantTwo = (data) => {
  return {
    type: actionTypes.BECOME_MERCHANT_TWO,
    data,
  };
};
export const becomerMerchantTwoSuccess = (data) => {
  return {
    type: actionTypes.BECOME_MERCHANT_TWO_SUCCESS,
    data,
  };
};
export const becomerMerchantTwoFail = () => {
  return {
    type: actionTypes.BECOME_MERCHANT_TWO_FAIL,
  };
};
/*===== END BECOME MERCHANT V2  =====*/
/*===== WALLET PIN =====*/
export const setWalletPin = (data) => {
  return {
    type: actionTypes.SET_WALLET_PIN,
    data,
  };
};
export const setWalletPinSuccess = () => {
  return {
    type: actionTypes.SET_WALLET_PIN_SUCCESS,
  };
};
export const setWalletPinFail = () => {
  return {
    type: actionTypes.SET_WALLET_PIN_FAIL,
  };
};
/*===== END WALLET PIN =====*/

/*===== PRODUCT PREFERENCE =====*/
export const setProductPreference = (data, toastSuccess = true) => {
  return {
    type: actionTypes.SET_PRODUCT_PREFERENCE,
    data,
    toastSuccess,
  };
};
export const setProductPreferenceSuccess = (data) => {
  return {
    type: actionTypes.SET_PRODUCT_PREFERENCE_SUCCESS,
    data,
  };
};
export const setProductPreferenceFail = () => {
  return {
    type: actionTypes.SET_PRODUCT_PREFERENCE_FAIL,
  };
};
export const showModalProductPreference = () => {
  return {
    type: actionTypes.SHOW_PRODUCT_PREFERENCE_MODAL,
  };
};
export const hideModalProductPreference = () => {
  return {
    type: actionTypes.HIDE_PRODUCT_PREFERENCE_MODAL,
  };
};
/*===== END PRODUCT PREFERENCE =====*/
